if (!customElements.get('project-catalog')) {
  customElements.define('project-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const grid = this.querySelector('[data-pc-grid]');
      const cards = [...this.querySelectorAll('[data-pc-card]')];
      const filters = [...this.querySelectorAll('[data-pc-filter]')];
      const sort = this.querySelector('[data-pc-sort]');
      let active = 'all';
      const update = () => {
        let count = 0;
        cards.forEach(card => {
          card.hidden = active !== 'all' && card.dataset.category !== active;
          if (!card.hidden) count++;
        });
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.pcFilter === active)));
        this.querySelector('[data-pc-count]').textContent = this.dataset.countLabel.replace('[count]', count);
        this.querySelector('[data-pc-empty]').hidden = count > 0;
        const ordered = [...cards].sort((a, b) => {
          const rank = Number(a.dataset.rank) - Number(b.dataset.rank);
          if (sort.value === 'low') return Number(a.dataset.price) - Number(b.dataset.price) || rank;
          if (sort.value === 'high') return Number(b.dataset.price) - Number(a.dataset.price) || rank;
          return rank;
        });
        ordered.forEach(card => grid.append(card));
      };
      filters.forEach(button => button.addEventListener('click', () => { active = button.dataset.pcFilter; update(); }));
      sort.addEventListener('change', update);
      this.querySelector('[data-pc-reset]').addEventListener('click', () => { active = 'all'; update(); filters[0].focus(); });
      this.querySelector('[data-pc-tools]').hidden = cards.length === 0;
      update();
    }
  });
}
